import { Breadcrumb, Menu } from 'antd';
import Link from 'next/link';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import MoreSvg from '../../../assets/icons/MoreSvg';
import theme from '../../../assets/theme';
import useRouterMatch from '../../../hooks/useRouterMatch';
import { FolderBreadCrumb } from '../../../services/TemplateService/Template.type';
import { IconWrapper } from '../../_atoms/IconWrapper';

const LessonBreadcrumbs = ({ breadcrumbs }: { breadcrumbs: FolderBreadCrumb[] }) => {
  const { t } = useTranslation('Host');
  const { tenantId } = useRouterMatch();
  const responsiveCrumbs = useMemo(() => {
    const root: FolderBreadCrumb = {
      id: '',
      title: t('My lessons'),
      parentId: null,
    };
    if (breadcrumbs.length < 3) return [root, ...breadcrumbs];
    const lastTwo = breadcrumbs.slice(-2);
    const firstCouple = breadcrumbs.slice(0, -2);
    const collapsedCrumb: FolderBreadCrumb = {
      id: 'not-used',
      title: '...',
      parentId: null,
      children: firstCouple,
    };
    return [root, collapsedCrumb, ...lastTwo];
  }, [breadcrumbs, t]);

  return (
    <BreadCrumbsWrapper>
      {responsiveCrumbs?.map((crumb, index) => {
        const hasChildren = !!crumb.children;

        if (hasChildren) {
          const menu = (
            <Menu>
              {crumb.children?.map(childCrumb => {
                return (
                  <Menu.Item key={childCrumb.id}>
                    <Link
                      href={`/${tenantId}/lessons${
                        childCrumb.id.length > 0 ? `?parentFolderId=${childCrumb.id}` : ''
                      }`}
                    >
                      <a>{childCrumb.title}</a>
                    </Link>
                  </Menu.Item>
                );
              })}
            </Menu>
          );
          return (
            <Breadcrumb.Item
              overlay={menu}
              key={index}
              dropdownProps={{ trigger: ['click'], overlay: menu }}
            >
              <IconWrapper
                style={{ display: 'inline-block', transform: 'rotate(90deg)' }}
                color={theme.colors.black}
                height="18px"
                width="18px"
              >
                <MoreSvg />
              </IconWrapper>
            </Breadcrumb.Item>
          );
        }
        return (
          <Breadcrumb.Item key={index}>
            <Link
              href={`/${tenantId}/lessons${
                crumb.id.length > 0 ? `?parentFolderId=${crumb.id}` : ''
              }`}
            >
              <a>{crumb.title}</a>
            </Link>
          </Breadcrumb.Item>
        );
      })}
    </BreadCrumbsWrapper>
  );
};

export default LessonBreadcrumbs;

const BreadCrumbsWrapper = styled.div`
  display: flex;
  ul,
  li {
    list-style: none;
  }
  a {
    font-size: 16px;
  }
  .anticon-down {
    display: none;
  }
`;
